import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const ImagesContext = createContext({ images: {}, timeline: undefined, refresh: () => {} });

export const ImagesProvider = ({ children }) => {
  const [overrides, setOverrides] = useState({});
  // undefined = still loading; null = no custom milestones saved
  const [timeline, setTimeline] = useState(undefined);

  const fetchAll = useCallback(() => {
    axios
      .get(`${BACKEND}/api/images`)
      .then((r) => {
        const map = {};
        Object.entries(r.data.images || {}).forEach(([slot, path]) => {
          map[slot] = `${BACKEND}${path}`;
        });
        setOverrides(map);
      })
      .catch(() => {});
    axios
      .get(`${BACKEND}/api/timeline`)
      .then((r) => setTimeline(r.data.milestones || null))
      .catch(() => setTimeline(null));
  }, []);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  useEffect(() => {
    if (overrides.logo) {
      const link = document.querySelector("link[rel='icon']");
      if (link) link.href = overrides.logo;
    }
  }, [overrides.logo]);

  return (
    <ImagesContext.Provider value={{ images: overrides, timeline, refresh: fetchAll }}>
      {children}
    </ImagesContext.Provider>
  );
};

export const useImageOverrides = () => useContext(ImagesContext).images;

export const useSiteImage = (slot, fallback) => useContext(ImagesContext).images[slot] || fallback;

export const useTimeline = () => useContext(ImagesContext).timeline;

export const useRefreshSiteContent = () => useContext(ImagesContext).refresh;
